import { render, staticRenderFns } from "./companies-management.vue?vue&type=template&id=6e904e24"
import script from "./companies-management.vue?vue&type=script&lang=js"
export * from "./companies-management.vue?vue&type=script&lang=js"
import style0 from "./companies-management.vue?vue&type=style&index=0&id=6e904e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports